// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"saveSettings_inputContainer_AZZUb","button":"saveSettings_button_2yoVW"};